<div class="responsive-nav-background" (click)="hideResponsiveMenu()"></div>
<div class="responsive-nav-container">
  <!-- Responsive nav -->
  <div class="responsive-nav-wrapper">
    <ul class="responsive-nav-list">
      <!-- User options -->
      <li class="responsive-nav-user">
        <ul>
          <!-- ANCHOR Active user -->
          <li class="responsive-nav-user-name">
            <div class="responsive-nav-user-name-container">
              <i class="fa fa-user fa-fw"></i>
              <div>
                <p>
                  {{ sessionUserName?.name + " " + sessionUserName?.surname }}
                </p>
                <app-arson-option-status />
              </div>
            </div>
            <div>
              <i class="fas fa-bars responsive-nav-menu-icon" (click)="hideResponsiveMenu()"></i>
            </div>
          </li>
          <ul class="responsive-nav-dropdowns">
            <li class="responsive-nav-dropdown-container">
              <button
                class="responsive-nav-dropdown-button"
                (click)="
                  dropdownActive != 'options'
                    ? (dropdownActive = 'options')
                    : (dropdownActive = '');
                  languageMenu = false;
                  resetAllSearchBox();
                  closeDropdown(responsiveOptionsDropdown)
                "
              >
                <div>
                  <i class="fa fa-cog fa-fw"></i>
                </div>
                <div>
                  <p class="responsive-nav-selected">
                    {{ "options" | translate }}
                  </p>
                  <span class="caret"></span>
                </div>
              </button>
            </li>
            <li
              #responsiveOptionsDropdown
              class="responsive-nav-user-dropdown"
              [ngClass]="{
                'responsive-nav-dropdown-active': dropdownActive === 'options'
              }"
            >
              <ul>
                <!-- ANCHOR Notifications -->
                <li>
                  <a (click)="hideResponsiveMenu(); notificationModal.showNotifications()">
                    <i
                      class="fa fa-bell fa-fw responsive-nav-dropdown-icon"
                      [ngClass]="{
                        'user-notification-active': pendingNotifications > 0
                      }"
                    ></i>
                    <p>{{ "notifications" | translate }}</p>
                  </a>
                </li>
                @if (sessionProfile == PROFILES.ARSON) {
                  <li>
                    <button
                      type="button"
                      class="responsive-nav-data-protection"
                      [attr.aria-pressed]="dataProtectionActive"
                      (click)="toggleDataProtection(); hideResponsiveMenu()"
                    >
                      <i class="fa-solid fa-shield-halved fa-fw responsive-nav-dropdown-icon"></i>
                      <span>{{ "data-protection" | translate }}</span>
                    </button>
                  </li>
                }
                <!-- ANCHOR User list -->
                @if (
                  (sessionProfile == PROFILES.ARSON ||
                    sessionProfile == PROFILES.USUARIO_ARSON ||
                    sessionProfile == PROFILES.ADMIN_ENTIDAD ||
                    sessionProfile == PROFILES.ADMIN_CLIENTE ||
                    sessionProfile == PROFILES.ADMIN_AGRUPACION ||
                    sessionProfile == PROFILES.ADMIN_INSTALLATION) &&
                  !ENVIRONMENT.demo
                ) {
                  <li>
                    <a [routerLink]="['/usuarios/listado']" (click)="hideResponsiveMenu()">
                      <i class="fa fa-users fa-fw responsive-nav-dropdown-icon"></i>
                      <p>{{ "user-list" | translate }}</p>
                    </a>
                  </li>
                }
                <!-- ANCHOR User log -->
                <li>
                  <a [routerLink]="['/usuarios/log/global']" (click)="hideResponsiveMenu()">
                    <i class="fas fa-list-alt fa-fw responsive-nav-dropdown-icon"></i>
                    <p>{{ "user-log" | translate }} - {{ "global" | translate }}</p>
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/usuarios/log/agrupacion']" (click)="hideResponsiveMenu()">
                    <i class="fas fa-list-alt fa-fw responsive-nav-dropdown-icon"></i>
                    <p>{{ "user-log" | translate }} - {{ "groups" | translate }}</p>
                  </a>
                </li>
                <!-- ANCHOR Account settings -->
                <li>
                  <a
                    [routerLink]="['/usuarios/formulario/editar/', currentUserId]"
                    (click)="hideResponsiveMenu()"
                  >
                    <i class="fas fa-cog fa-fw responsive-nav-dropdown-icon"></i>
                    <p>{{ "user-configuration" | translate }}</p>
                  </a>
                </li>
                <!-- ANCHOR Reset map settings -->
                <li class="option-highlighted-red">
                  <a (click)="hideResponsiveMenu(); resetMapSettings()">
                    <i class="fas fa-map fa-fw responsive-nav-dropdown-icon"></i>
                    <p>{{ "reset-map-settings" | translate }}</p>
                  </a>
                </li>
                <!-- ANCHOR Delete local profile -->
                <li>
                  <a (click)="hideResponsiveMenu(); deleteUserLocalSettings()">
                    <i class="fas fa-eraser fa-fw responsive-nav-dropdown-icon"></i>
                    <p>{{ "user-local-configuration-delete" | translate }}</p>
                  </a>
                </li>
                <!-- ANCHOR Language -->
                <li
                  (click)="
                    languageMenu = !languageMenu;
                    dropdownActive = 'options';
                    closeDropdown(responsiveSearchDropdown);
                    resetAllSearchBox()
                  "
                >
                  <i class="fas fa-globe fa-fw responsive-nav-dropdown-icon"></i>
                  <p>{{ "change-language" | translate }}</p>
                </li>
                <!-- ANCHOR Language selector -->
                <li
                  class="responsive-nav-language-dropdown"
                  [ngClass]="{
                    'responsive-nav-dropdown-inactive': !languageMenu
                  }"
                >
                  <ul>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.ESPANOL); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/spain-flag.png' }}"
                        />
                        <p>Castellano</p>
                      </a>
                    </li>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.INGLES); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/uk-flag.png' }}"
                        />
                        <p>English</p>
                      </a>
                    </li>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.CATALAN); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/cat-flag.png' }}"
                        />
                        <p>Catalá</p>
                      </a>
                    </li>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.FRANCES); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/france-flag.png' }}"
                        />
                        <p>Français</p>
                      </a>
                    </li>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.ITALIANO); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/it-flag.png' }}"
                        />
                        <p>Italiano</p>
                      </a>
                    </li>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.GRIEGO); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/el-flag.png' }}"
                        />
                        <p>Ελληνικά</p>
                      </a>
                    </li>
                    <li>
                      <a (click)="switchLanguage(LANGUAGE.PORTUGUES); languageMenu = !languageMenu">
                        <img
                          class="responsive-nav-language-img"
                          src="{{ 'assets/img/languages/pt-flag.png' }}"
                        />
                        <p>Português</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <!-- ANCHOR Styles -->
                @if (sessionProfile == PROFILES.ARSON) {
                  <li
                    (click)="
                      themeMenu = !themeMenu;
                      dropdownActive = 'options';
                      closeDropdown(responsiveSearchDropdown);
                      resetAllSearchBox()
                    "
                  >
                    <i class="fas fa-palette fa-fw responsive-nav-dropdown-icon"></i>
                    <p>{{ "themes" | translate }}</p>
                  </li>
                }
                <!-- ANCHOR Style selector -->
                <li
                  class="responsive-nav-language-dropdown"
                  [ngClass]="{ 'responsive-nav-dropdown-inactive': !themeMenu }"
                >
                  <ul>
                    <li>
                      <a (click)="updateTheme('default'); themeMenu = !themeMenu">
                        {{ "theme-default" | translate }}
                      </a>
                    </li>
                    <li>
                      <a (click)="updateTheme('water'); themeMenu = !themeMenu">
                        {{ "theme-water" | translate }}
                      </a>
                    </li>
                    <li>
                      <a (click)="updateTheme('gas'); themeMenu = !themeMenu">
                        {{ "theme-gas" | translate }}
                      </a>
                    </li>
                    <li>
                      <a (click)="updateTheme('nortegas'); themeMenu = !themeMenu">Nortegas</a>
                    </li>
                    <!-- <li>
                      <a (click)="updateTheme('dark'); themeMenu = !themeMenu">
                        {{ "theme-dark" | translate }}
                      </a>
                    </li> -->
                    <li>
                      <a (click)="updateTheme('highContrast'); themeMenu = !themeMenu">
                        {{ "theme-high-contrast" | translate }}
                      </a>
                    </li>
                  </ul>
                </li>
                <!-- Logout -->
                <li>
                  <a (click)="logout()">
                    <i class="fa fa-sign-out-alt fa-fw"></i>
                    <p>{{ "logout" | translate }}</p>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </ul>
      </li>

      <!-- ANCHOR Client, entity and agrupation selectors -->
      <li>
        <ul class="responsive-nav-dropdowns">
          <!-- Client dropdown -->
          @if (sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON) {
            <li class="responsive-nav-dropdown-container">
              <button
                class="responsive-nav-dropdown-button"
                (click)="
                  dropdownActive != 'client' ? (dropdownActive = 'client') : (dropdownActive = '');
                  languageMenu = false;
                  resetAllSearchBox();
                  closeDropdown(responsiveSearchDropdown)
                "
              >
                <div>
                  <i class="fa fa-users fa-fw"></i>
                  <!-- <p>{{'clients' | translate}}</p> -->
                </div>
                <div>
                  @if (!currentClient) {
                    <p class="responsive-nav-selected">-</p>
                  }
                  @if (currentClient) {
                    <p class="responsive-nav-selected">
                      {{ currentClient.clientName }}
                    </p>
                  }
                  <span class="caret"></span>
                </div>
              </button>
            </li>
          }
          <li
            #responsiveClientDropdown
            class="responsive-nav-dropdown"
            [ngClass]="{
              'responsive-nav-dropdown-active': dropdownActive === 'client'
            }"
          >
            <!-- Client list -->
            <a [routerLink]="['/clientes/listado']" (click)="hideResponsiveMenu()">
              <i class="fa fa-list fa-fw responsive-nav-dropdown-icon"></i>
              {{ "list" | translate }}
            </a>
            <!-- New client -->
            <a [routerLink]="['/clientes/formulario/nuevo']" (click)="hideResponsiveMenu()">
              <i class="fa fa-plus fa-fw responsive-nav-dropdown-icon"></i>
              {{ "new" | translate }}
            </a>
            <!-- Client filter -->
            @if (clientList) {
              <div class="responsive-nav-dropdown-filter">
                <form autocomplete="off">
                  <input
                    #responsiveClientFilter
                    class="responsive-nav-dropdown-input"
                    type="text"
                    id="clientFilter"
                    name="clientFilter"
                    autocomplete="off"
                    (keyup)="dropdownFilter($event.target.value, 'client')"
                    placeholder="{{ 'search' | translate }}..."
                    (click)="searchActive = 'client'"
                  />
                  <!-- <i *ngIf="searchActive != 'client'" class="fas fa-caret-down responsive-nav-dropdown-caret" (click)="searchActive = searchActive == 'client' ? null : 'client' "></i>
                  <i *ngIf="searchActive == 'client'" class="fas fa-caret-up responsive-nav-dropdown-caret" (click)="searchActive = searchActive == 'client' ? null : 'client' "></i> -->
                </form>
              </div>
            }
            <!-- Client selector -->
            @if (clientList) {
              <ul class="responsive-nav-dropdown-select">
                @for (client of clientList; track client) {
                  <li
                    (click)="
                      updateCurrentClient(client);
                      resetSearchBox(responsiveClientFilter, 'client');
                      closeDropdown(responsiveClientDropdown)
                    "
                  >
                    <i class="fa fa-user-tie fa-fw responsive-nav-dropdown-icon"></i>
                    <p class="responsive-nav-dropdown-option">
                      {{ client.clientName }}
                    </p>
                  </li>
                }
              </ul>
            }
          </li>

          <!-- Entity dropdown -->
          <li class="responsive-nav-dropdown-container">
            <button
              class="responsive-nav-dropdown-button"
              (click)="
                dropdownActive != 'entity' ? (dropdownActive = 'entity') : (dropdownActive = '');
                languageMenu = false;
                resetAllSearchBox();
                closeDropdown(responsiveSearchDropdown)
              "
            >
              <div>
                <i class="fa fa-sitemap fa-fw"></i>
                <!-- <p>{{'entities' | translate}}</p> -->
              </div>
              <div>
                @if (!currentEntity) {
                  <p class="responsive-nav-selected">-</p>
                }
                @if (currentEntity) {
                  <p class="responsive-nav-selected">
                    {{ currentEntity.entity }}
                  </p>
                }
                <span class="caret"></span>
              </div>
            </button>
          </li>
          <li
            #responsiveEntityDropdown
            class="responsive-nav-dropdown"
            [ngClass]="{
              'responsive-nav-dropdown-active': dropdownActive === 'entity'
            }"
          >
            <!-- Entity list -->
            @if (sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON) {
              <a [routerLink]="['/entidades/listado']" (click)="hideResponsiveMenu()">
                <i class="fa fa-list fa-fw responsive-nav-dropdown-icon"></i>
                {{ "list" | translate }}
              </a>
            }
            <!-- New entity -->
            @if (sessionProfile == PROFILES.ARSON) {
              <a [routerLink]="['/entidades/formulario/nuevo']" (click)="hideResponsiveMenu()">
                <i class="fa fa-plus fa-fw responsive-nav-dropdown-icon"></i>
                {{ "new" | translate }}
              </a>
            }
            <!-- Entity filter -->
            @if (entityList) {
              <div class="responsive-nav-dropdown-filter">
                <form autocomplete="off">
                  <input
                    #responsiveEntityFilter
                    class="responsive-nav-dropdown-input"
                    type="text"
                    id="entityFilter"
                    name="entityFilter"
                    autocomplete="off"
                    (keyup)="dropdownFilter($event.target.value, 'entity')"
                    placeholder="{{ 'search' | translate }}..."
                    (click)="searchActive = 'entity'"
                  />
                  <!-- <i *ngIf="searchActive != 'entity'" class="fas fa-caret-down responsive-nav-dropdown-caret" (click)="searchActive = searchActive == 'entity' ? null : 'entity' "></i>
                  <i *ngIf="searchActive == 'entity'" class="fas fa-caret-up responsive-nav-dropdown-caret" (click)="searchActive = searchActive == 'entity' ? null : 'entity' "></i> -->
                </form>
              </div>
            }
            <!-- Entity selector -->
            @if (entityList) {
              <ul class="responsive-nav-dropdown-select">
                @for (entity of entityList; track entity) {
                  <li
                    (click)="
                      updateCurrentEntity(entity);
                      resetSearchBox(responsiveEntityFilter, 'entity');
                      closeDropdown(responsiveEntityDropdown)
                    "
                  >
                    <i class="fas fa-project-diagram fa-fw responsive-nav-dropdown-icon"></i>
                    <p class="responsive-nav-dropdown-option">
                      {{ entity.entity }}
                    </p>
                  </li>
                }
              </ul>
            }
          </li>

          <!-- Agrupation dropdown -->
          <li class="responsive-nav-dropdown-container">
            <button
              class="responsive-nav-dropdown-button"
              (click)="
                dropdownActive != 'agrupation'
                  ? (dropdownActive = 'agrupation')
                  : (dropdownActive = '');
                languageMenu = false;
                resetAllSearchBox();
                closeDropdown(responsiveSearchDropdown)
              "
            >
              <div>
                <i class="fa fa-map fa-fw"></i>
                <!-- <p>{{'agrupations' | translate}}</p> -->
              </div>
              <div>
                @if (!currentAgrupation) {
                  <p class="responsive-nav-selected">-</p>
                }
                @if (currentAgrupation) {
                  <p class="responsive-nav-selected">
                    {{ currentAgrupation.name }}
                  </p>
                }
                <span class="caret"></span>
              </div>
            </button>
          </li>
          <li
            #responsiveAgrupationDropdown
            class="responsive-nav-dropdown"
            [ngClass]="{
              'responsive-nav-dropdown-active': dropdownActive == 'agrupation'
            }"
          >
            <!-- Agrupation list -->
            @if (
              sessionProfile == PROFILES.ARSON ||
              sessionProfile == PROFILES.USUARIO_ARSON ||
              sessionProfile == PROFILES.ADMIN_ENTIDAD ||
              sessionProfile == PROFILES.ADMIN_CLIENTE
            ) {
              <a [routerLink]="['/agrupaciones/listado']" (click)="hideResponsiveMenu()">
                <i class="fa fa-list fa-fw responsive-nav-dropdown-icon"></i>
                {{ "list" | translate }}
              </a>
            }
            <!-- New agrupation -->
            @if (
              sessionProfile == PROFILES.ARSON ||
              sessionProfile == PROFILES.ADMIN_ENTIDAD ||
              sessionProfile == PROFILES.ADMIN_CLIENTE
            ) {
              <a [routerLink]="['/agrupaciones/formulario/nuevo']" (click)="hideResponsiveMenu()">
                <i class="fa fa-plus fa-fw responsive-nav-dropdown-icon"></i>
                {{ "new" | translate }}
              </a>
            }
            <!-- Agrupation filter -->
            @if (agrupationList) {
              <div class="responsive-nav-dropdown-filter">
                <form autocomplete="off">
                  <input
                    #responsiveAgrupationFilter
                    class="responsive-nav-dropdown-input"
                    type="text"
                    id="agrupationFilter"
                    name="agrupationFilter"
                    autocomplete="off"
                    (keyup)="dropdownFilter($event.target.value, 'group')"
                    placeholder="{{ 'search' | translate }}..."
                    (click)="searchActive = 'agrupation'"
                  />
                  <!-- <i *ngIf="searchActive != 'agrupation'" class="fas fa-caret-down responsive-nav-dropdown-caret" (click)="searchActive = searchActive == 'agrupation' ? null : 'agrupation' "></i>
                  <i *ngIf="searchActive == 'agrupation'" class="fas fa-caret-up responsive-nav-dropdown-caret" (click)="searchActive = searchActive == 'agrupation' ? null : 'agrupation' "></i> -->
                </form>
              </div>
            }
            <!-- Agrupation selector -->
            @if (agrupationList) {
              <ul class="responsive-nav-dropdown-select">
                @for (agrupation of agrupationList; track agrupation) {
                  <li
                    (click)="
                      updateCurrentAgrupation(agrupation);
                      resetSearchBox(responsiveAgrupationFilter, 'agrupation');
                      closeDropdown(responsiveAgrupationDropdown)
                    "
                  >
                    <i class="far fa-map fa-fw responsive-nav-dropdown-icon"></i>
                    <p class="responsive-nav-dropdown-option">
                      {{ agrupation.name }}
                    </p>
                  </li>
                }
              </ul>
            }
          </li>
        </ul>
      </li>

      <li>
        <app-navbar-top-search-navigation [responsive]="true"></app-navbar-top-search-navigation>
      </li>

      <!-- ANCHOR Device/CUPS search -->
      <li class="responsive-nav-dropdown-container">
        <button
          class="responsive-nav-dropdown-button"
          (click)="
            dropdownActive != 'search' ? (dropdownActive = 'search') : (dropdownActive = '');
            languageMenu = false;
            resetAllSearchBox()
          "
        >
          <div>
            <i class="fas fa-search"></i>
          </div>
          <div>
            <p class="responsive-nav-selected">
              {{ "search" | translate }}
            </p>
            <span class="caret"></span>
          </div>
        </button>
      </li>
      <li
        #responsiveSearchBoxDropdown
        class="responsive-nav-dropdown"
        [ngClass]="{
          'responsive-nav-dropdown-active': dropdownActive == 'search'
        }"
      >
        <!-- <li
        class="responsive-nav-search-box-container"
        (click)="
          openDropdown(responsiveSearchDropdown, 'search');
          dropdownActive = '';
          languageMenu = false;
          resetAllSearchBox()
        "
        >
        <div class="responsive-nav-search-box-title">
          <i class="fas fa-search"></i>
          <p>{{ "search" | translate }}</p>
        </div> -->
        <div class="responsive-nav-search-border">
          @if (currentCupsName) {
            <div class="responsive-nav-search-options">
              <button
                #searchDeviceResponsiveButton
                type="button"
                (click)="searchSelect('device'); resetSearchBox(responsiveSearchFilter, 'search')"
                [ngClass]="{
                  'responsive-nav-search-options--active': !cupsSelected,
                  'responsive-nav-search-options--inactive': cupsSelected,
                  'search-devices-long': !currentCupsName
                }"
              >
                {{ "device" | translate }}
              </button>
              <button
                type="button"
                (click)="searchSelect('cups'); resetSearchBox(responsiveSearchFilter, 'search')"
                [ngClass]="{
                  'responsive-nav-search-options--active': cupsSelected,
                  'responsive-nav-search-options--inactive': !cupsSelected,
                  'search-cups-long': currentCupsName.length > 15
                }"
              >
                {{ currentCupsName }}
              </button>
            </div>
          }
          <div class="responsive-nav-search-box">
            <!-- Meter/CUPS filter -->
            <div class="responsive-nav-search-filter">
              <form autocomplete="off">
                <input
                  #responsiveSearchFilter
                  class="responsive-nav-search-input"
                  type="text"
                  id="searchFilter"
                  name="searchFilter"
                  autocomplete="off"
                  (keyup)="dropdownFilter($event.target.value, 'search', cupsSelected)"
                  placeholder="{{ searchOptionSelected }}..."
                  (click)="searchActive = 'search'; openDropdown(responsiveSearchDropdown)"
                />
                @if (searchActive != "search") {
                  <i
                    class="fas fa-caret-down responsive-nav-search-caret"
                    (click)="
                      searchActive = searchActive == 'search' ? null : 'search';
                      openDropdown(responsiveSearchDropdown)
                    "
                  ></i>
                }
                @if (searchActive == "search") {
                  <i
                    class="fas fa-caret-up responsive-nav-search-caret"
                    (click)="
                      searchActive = searchActive == 'search' ? null : 'search';
                      closeDropdown(responsiveSearchDropdown)
                    "
                  ></i>
                }
              </form>
            </div>
            <div #responsiveSearchDropdown class="responsive-nav-search-dropdown">
              <!-- Meter selector -->
              @if (!cupsSelected && searchActive == "search") {
                <div #metersListContainer class="responsive-nav-search-select">
                  <cdk-virtual-scroll-viewport
                    #metersScroll
                    itemSize="10"
                    class="responsive-nav-virtual-scroller"
                  >
                    @for (meter of _meterList; track meter) {
                      <div
                        (click)="
                          goToSelection(cupsSelected, meter);
                          resetSearchBox(responsiveSearchFilter, 'search');
                          hideResponsiveMenu()
                        "
                      >
                        <p class="responsive-nav-search-option">
                          {{ meter.descripcion }}
                        </p>
                      </div>
                    }
                  </cdk-virtual-scroll-viewport>
                </div>
              }
              <!-- CUPS selector -->
              @if (cupsSelected && searchActive == "search") {
                <div #cupsListContainer class="responsive-nav-search-select">
                  <cdk-virtual-scroll-viewport
                    #cupsScroll
                    itemSize="10"
                    class="responsive-nav-virtual-scroller"
                  >
                    @for (cups of _cupsList; track cups) {
                      <div
                        (click)="
                          goToSelection(cupsSelected, cups);
                          resetSearchBox(responsiveSearchFilter, 'search');
                          hideResponsiveMenu()
                        "
                      >
                        <p class="responsive-nav-search-option">
                          {{ cups.descripcion | dataProtected }}
                        </p>
                      </div>
                    }
                  </cdk-virtual-scroll-viewport>
                </div>
              }
            </div>
          </div>
        </div>
      </li>

      <!-- ANCHOR Navigation links -->
      <li>
        @if (sessionProfile != PROFILES.ABONADO && menuList) {
          <ul class="responsive-nav-links">
            @for (menuList of menuListBy3; track $index) {
              <!-- Menu -->
              @for (menu of menuList; track menu.name) {
                @if (menu.profile) {
                  <li
                    class="responsive-nav-menu"
                    [ngClass]="{ 'disabled disabled-link': menu.disabled }"
                    (click)="
                      menuActive == menu.name ? (menuActive = '') : (menuActive = menu.name);
                      resetAllSearchBox();
                      dropdownActive = '';
                      languageMenu = false;
                      closeDropdown(responsiveSearchDropdown)
                    "
                  >
                    <!-- Link -->
                    <a
                      class="responsive-nav-link"
                      [ngClass]="{
                        'responsive-nav-link-active': menuActive == menu.name
                      }"
                      [routerLink]="menu.link ? [menu.link] : null"
                      (click)="!menu.submenu ? hideResponsiveMenu() : null"
                    >
                      <!-- Icon -->
                      <div>
                        <i class="{{ menu.icon }}"></i>
                      </div>
                    </a>
                  </li>
                }
              }
              <!-- Submenu -->
              @for (menu of menuList; track menu.name) {
                <li
                  class="responsive-nav-submenu-container"
                  [ngClass]="{
                    'responsive-nav-submenu-active': menuActive == menu.name
                  }"
                >
                  <ul>
                    <!-- Submenu > Toggled title -->
                    <li>
                      <div class="responsive-nav-menu-title-toggled">
                        <span>{{ menu.name | translate }}</span>
                      </div>
                    </li>
                    @for (submenu of menu.submenu; track submenu.name) {
                      <!-- Menu > Submenu -->
                      @if (submenu.profile && !submenu.submenu) {
                        <li
                          [ngClass]="{
                            'disabled disabled-link': submenu.disabled,
                            'submenu-title': !submenu.link
                          }"
                        >
                          <a
                            [ngClass]="{
                              'disabled-link-text': submenu.disabled
                            }"
                            [routerLink]="[submenu.link]"
                            (click)="hideResponsiveMenu()"
                          >
                            <div class="submenu-icon">
                              <i class="{{ submenu.icon }}"></i>
                              @if (submenu?.subicon) {
                                <i class="{{ submenu.subicon }} submenu-subicon"></i>
                              }
                            </div>
                            <span>{{ submenu.name | translate }}</span>
                          </a>
                        </li>
                      }
                      <!-- Menu > Submenu > Submenu -->
                      @if (submenu.profile && submenu.submenu) {
                        <li>
                          <a class="submenu-submenu-title">
                            <div class="submenu-icon">
                              <i class="{{ submenu.icon }}"></i>
                              @if (submenu?.subicon) {
                                <i class="{{ submenu.subicon }} submenu-subicon"></i>
                              }
                            </div>
                            <span>{{ submenu.name | translate }}</span>
                          </a>
                          <ul class="responsive-nav-submenu-submenu-container">
                            @for (submenuSubmenu of submenu.submenu; track submenuSubmenu) {
                              @if (submenuSubmenu.profile) {
                                <li>
                                  <a
                                    [ngClass]="{
                                      'disabled-link-text': submenuSubmenu.disabled
                                    }"
                                    [routerLink]="[submenuSubmenu.link]"
                                    (click)="hideResponsiveMenu()"
                                  >
                                    <div class="submenu-icon">
                                      <i class="{{ submenuSubmenu.icon }}"></i>
                                      @if (submenu?.subicon) {
                                        <i class="{{ submenu.subicon }} submenu-subicon"></i>
                                      }
                                    </div>
                                    <span>{{ submenuSubmenu.name | translate }}</span>
                                  </a>
                                </li>
                              }
                            }
                          </ul>
                        </li>
                      }
                    }
                  </ul>
                </li>
              }
            }
          </ul>
        }
      </li>
    </ul>
  </div>
</div>
